export default __webpack_public_path__ + "static/media/index.d.f8eb360d.ts";